import {
  Component,
  HostBinding,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { convertMillisToHoursMinutes } from 'src/app/@core/utils/convertMillisToHoursMinutes.functions';
import {
  DatatableColumn,
  DatatableColumnType,
} from 'src/app/@theme/datatable/datatable.component';
import { RankListResponseWrapper } from 'src/app/api/models';

export interface RoomChampionsRow {
  month: string;
  easy?: ResultInfo;
  medium?: ResultInfo;
  hard?: ResultInfo;
  master?: ResultInfo;
}

type ResultInfo = { teamName: string; time: string; picture: string };

@Component({
  selector: 'app-roomchampions',
  templateUrl: './roomchampions.component.html',
  styleUrls: ['./roomchampions.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class RoomchampionsComponent {
  roomChampions: RankListResponseWrapper[] = [];
  roomChampion: RoomChampionsRow[] = [];
  searchable: boolean = false;

  @Input() loading: boolean = false;
  @Input() theme: string = '';

  columns: DatatableColumn[] = [
    { prop: 'month', name: '', sortable: false, width: 125 },
    {
      prop: 'easy',
      name: 'Easy',
      width: 125,
      sortable: false,
      type: DatatableColumnType.ARRAY,
    },
    {
      prop: 'medium',
      name: 'Medium',
      width: 125,
      sortable: false,
      type: DatatableColumnType.ARRAY,
    },
    {
      prop: 'hard',
      name: 'Hard',
      width: 125,
      sortable: false,
      type: DatatableColumnType.ARRAY,
    },
    {
      prop: 'x_hard',
      name: 'Master',
      width: 125,
      sortable: false,
      type: DatatableColumnType.ARRAY,
    },
  ];

  @Input('roomChampions') set setRoomChampions(roomChampions: any[]) {
    this.roomChampions = roomChampions;
    this.mapRoomChampionRows();
  }

  @HostBinding('class.light-theme') get isLightTheme() {
    return this.theme === 'light';
  }
  @HostBinding('class.dark-theme') get isDarkTheme() {
    return this.theme === 'dark';
  }

  private mapRoomChampionRows(): void {
    if (this.roomChampions) {
      const result: RoomChampionsRow[] = [];

      this.roomChampions.forEach((champion) => {
        champion.data!.forEach(
          (entry: {
            time?: any;
            month?: any;
            level?: any;
            picture?: any;
            teamName?: any;
            averageGameTime?: any;
          }) => {
            const { month, level, picture, teamName, averageGameTime } = entry;

            const existingRoom = result.find((item) => item.month === month);
            const timeInHoursAndMinutes = convertMillisToHoursMinutes(
              entry.time,
            );
            const timeOfAllGame =
              'all games avg: ' +
              convertMillisToHoursMinutes(entry.averageGameTime);

            if (!existingRoom) {
              const newRoomObj = {
                month,
                easy: { teamName: '', time: '', picture: '', timeAverage: '' },
                medium: {
                  teamName: '',
                  time: '',
                  picture: '',
                  timeAverage: '',
                },
                hard: { teamName: '', time: '', picture: '', timeAverage: '' },
                x_hard: {
                  teamName: '',
                  time: '',
                  picture: '',
                  timeAverage: '',
                },
              };
              (newRoomObj as any)[level?.toLowerCase()] = {
                picture: picture
                  ? picture
                  : '../../../../assets/noteampicture.png',
                timeInHoursAndMinutes,
                teamName,
                timeOfAllGame,
              };
              result.push(newRoomObj);
            } else {
              (existingRoom as any)[level?.toLowerCase()] = {
                picture: picture
                  ? picture
                  : '../../../../assets/noteampicture.png',
                timeInHoursAndMinutes,
                teamName,
                timeOfAllGame,
              };
            }
          },
        );
      });

      this.roomChampion = result.sort((a, b) => (a.month > b.month ? -1 : 1));
    }
  }
}
